<div class="width-1100">

    <mat-card>
        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <div>Helper</div>
            </div>

        </mat-toolbar>
    </mat-card>

    <mat-card id='table-body'>

        <!-- TABLE -->
        <mat-table [dataSource]="_helperService.dataSource">

            <!-- id Column -->
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.id }} </mat-cell>
            </ng-container>

            <!-- date Column -->
            <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.date.seconds*1000 | date: 'dd/MM/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="deleted">
                <mat-header-cell *matHeaderCellDef> Deleted </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.deleted }}
                </mat-cell>
            </ng-container>

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

    </mat-card>

</div>